import { render, staticRenderFns } from "./PaymentProviderSettings.vue?vue&type=template&id=26cc342d"
import script from "./PaymentProviderSettings.vue?vue&type=script&lang=js"
export * from "./PaymentProviderSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports